import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Utils/store/store';

export default createSelector(
    (state: RootState) => state.reducerUser,
    reducerUser => reducerUser?.id || 0,
);
